import { render, staticRenderFns } from "./WorkCalendar.vue?vue&type=template&id=33490d36&scoped=true"
import script from "./WorkCalendar.vue?vue&type=script&lang=js"
export * from "./WorkCalendar.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendar.vue?vue&type=style&index=0&id=33490d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33490d36",
  null
  
)

export default component.exports